/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import AgreementCopy from 'material/agreementcopy/aggreementcopy';
import {
    Page,
    Group,
    Copy,
    Title,
    BodyCopy,
    CTAs,
    Link,
    Button,
    Form,
    Grid,
    GridSet,
    GridItem,
    Content,
    Icon,
    LoadState,
    TextField,
    PasswordVerification,
    clearCookies,
    InlineMessage,
    log
} from '@insticator/insticator-ui'; // iui-material
//utils
import { isFormValid } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from './completesignup_styles';



/* ========== ~~~~~~~~~~  AUTH COMPLETE SIGNUP ~~~~~~~~~~ ========== */
class CompleteSignUpPage extends Component {
    constructor(props){
        super(props);
        this.formName = 'completesignup';
        this.state = {
            ready: true,
            newPasswordFocus: false,
            newPasswordVisible: false,
            confirmPasswordVisible: false,
            isCommentingEmailChecked: false
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.userEmail && !this.state.isCommentingEmailChecked) {
            log('CHECKING IF EMAIL HAS COMMENTING ACCOUNT', this.props.userEmail)
            this.props.getCommentingEmailIfExist(this.props.userEmail); 
            this.setState({isCommentingEmailChecked: true})
        }
    }

    handleSubmit = () => {
        const callData = this.getFormCallData();
        if(this.readyToSubmit(callData)) this.props.completeSignUpWithValidation(this.props.fields, callData, this.handleSucessfulSignUp, this.handleFailedSignUp)
    };

    getFormCallData = () => ({
        userUUID: this.props.userUUID,
        updatedPassword: this.props.fields.newPassword.value,
    });

    readyToSubmit = () => {
        if (!this.passwordsMatch()) {
            this.props.displayErrorMessage(`Woops, something wrong: The entered passwords don't match.`);
            return false;
        }
        return true;
    };

    passwordsMatch = () => this.props.fields.newPassword.value === this.props.fields.confirmedPassword.value;

    handleSucessfulSignUp = () => {
        const successMessage = 'Signup completed successfully';
        clearCookies(['show_set_password']);
        this.props.displaySuccessMessage(successMessage);
        // Update agreement info is for classic and not needed anymore for V2.
        // if (this.props.showTermsAndConditions) {
        //     this.props.updateAgreementInfo(this.props.agreementUUID, this.props.userUUID, this.handleSignedAgreement);
        // } else {
        //     this.props.moveToPage('auth/signupcomplete');
        // }
        this.props.moveToPage('auth/signupcomplete');
    };

    handleSignedAgreement = ({ success }) => this.props.moveToPage(`auth/${success ? 'signupcomplete' : 'acceptagreement'}`);
    
    handleFailedSignUp = () => console.log('Signup is not completed');

    handleNewPasswordFocus = () => this.setState({ newPasswordFocus: true });

    newPasswordVisibilityIcon = () => <Link type={'action'}
                                            action={this.handleNewPasswordIconClick}
                                            icon={this.state.newPasswordVisible ? 'eye' : 'eye-slash'}
                                            underline={false}/>;

    handleNewPasswordIconClick = () => this.setState({ newPasswordVisible: !this.state.newPasswordVisible });

    confirmPasswordVisibilityIcon = () => <Link type={'action'}
                                                action={this.handleConfirmPasswordIconClick}
                                                icon={this.state.confirmPasswordVisible ? 'eye' : 'eye-slash'}
                                                underline={false}/>;

    handleConfirmPasswordIconClick = () => this.setState({ confirmPasswordVisible: !this.state.confirmPasswordVisible });

    render() {
        const { newPassword, confirmedPassword} = this.props.fields;

        return(
            <Page name={this.formName} klass={this.props.classes.completesignup}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Welcome!</h2>
                        </Title>
                        <BodyCopy>
                            <p>Please create your new password</p>
                        </BodyCopy>
                        { this.props.commentingEmailAlreadyExist && 
                            <InlineMessage 
                                icon={`info-circle`}
                                message={<p>This is also the password you will use when logging into your commenting account under this same email.</p>}
                            />
                        }
                    </Copy>
                    <Form name={`completesignup`} editable={this.state.ready && !this.props.completesignup.savingData} >
                        <Grid type={`fields`}>
                            <GridSet direction={`vertical`}>
                                <GridItem>
                                    <TextField
                                        type={this.state.newPasswordVisible ? `text` : `password`}
                                        name={`newPassword`}
                                        value={newPassword.value}
                                        valid={newPassword.valid}
                                        formName={this.formName}
                                        placeholder={`Password`}
                                        label={`New Password`}
                                        handleFocus={this.handleNewPasswordFocus}
                                        iconRight={this.newPasswordVisibilityIcon()}
                                        required />
                                </GridItem>
                                {this.state.newPasswordFocus && <GridItem><PasswordVerification password={newPassword.value} /></GridItem>}
                                <GridItem>
                                    <TextField
                                        type={this.state.confirmPasswordVisible ? `text` : `password`}
                                        name={`confirmedPassword`}
                                        value={confirmedPassword.value}
                                        valid={confirmedPassword.valid}
                                        compareTo={newPassword.value}
                                        formName={this.formName} placeholder={`Password`}
                                        label={`Confirm New Password`}
                                        info={``}
                                        iconRight={this.confirmPasswordVisibilityIcon()}
                                        required />
                                </GridItem>
                                {this.props.showTermsAndConditions && <GridItem>
                                    <AgreementCopy clickDescription={'Submit'} />
                                </GridItem>}
                            </GridSet>
                        </Grid>
                        <CTAs>
                            <Button type={'action'}
                                    disabled={!isFormValid(this.props.fields)}
                                    action={this.handleSubmit}
                                    variant={`primary`} name={`signup`}
                                    text={`Submit`}
                                    processing={this.props.completesignup.savingData}
                                    operation={'load'} />
                        </CTAs>
                    </Form>
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CompleteSignUpPage);
